import ReactDom from "react-dom";
import LoginButton from "./LoginButton.jsx";

export default function renderLoginButton() {
  document.querySelectorAll(".js-login-mount").forEach((mount) => {
    const data = JSON.parse(mount.getAttribute("data-model"));

    // the form might not be there (if the user is logged in)
    const formEl = mount.querySelector("form");
    const formHTML = formEl && formEl.outerHTML;

    ReactDom.render(<LoginButton {...data} formHTML={formHTML} />, mount);

    // it's hidden initally so the user doesn't see the form html
    mount.style.display = "block";
  });
}
